import { IPrinterReceiptItem } from '../../interfaces';
import { IReceiptItem } from '../../interfaces/receipt-item.interface';
import { replaceWithLatinSymbols } from '@core/services/utils/latin-symbols.utils';

/**
 * Epson builds receipts with the ANK character model on both platforms, so it can
 * only print the ASCII/Latin-1 subset. Letters outside of it are lost on the way to
 * the hardware and have to be transliterated first.
 */
export class EpsonReceiptItem implements IPrinterReceiptItem<IReceiptItem> {
  async getReceipt(receipt: IReceiptItem[]): Promise<IReceiptItem[]> {
    return receipt.map((item) => (item.text ? { ...item, text: item.text.replace(/[\u0100-\uFFFF]/g, replaceWithLatinSymbols) } : item));
  }
}
